<template>
  <div class="col_4">
    <div class="card vlan_home_email_trackers">
      <div class="card_heading">
        <div class="fw_600">To-do ({{ todos.length ?? 0 }})</div>
      </div>
      <div class="card_body">
        <div class="t_c_todo_wrap">
          <!--          <div class="form_input mb_10 mt_15">
            <input type="text" v-model="form.content" class="form_global" placeholder="Add To Do" @keypress.enter="addUpdateTodo">
          </div>-->
          <div v-for="todo in todos" :key="'todo_' + todo.id" class="inner">
            <div class="inner_wrap">
              <div class="contact_name">
                <div class="checked_todo">
                  <div class="form_checkbox p_0">
                    <input
                      type="checkbox"
                      :id="'todo-' + todo.id"
                      value="1"
                      v-model="todo.status"
                      :true-value="1"
                      :false-value="0"
                      @change="markAsCompleted(todo)"
                    />
                    <label :for="'todo-' + todo.id" class="pl_10"></label>
                  </div>
                </div>
                <div class="text">
                  <RouterLink
                    :to="{
                      name: 'view-ticket',
                      params: { ticket_number: todo?.ticket?.ticket_number },
                    }"
                  >
                    <h2 class="fw_500 font_16p">{{ todo.content }}</h2>
                  </RouterLink>
                </div>
              </div>
              <!--              <div class="on_hover">
                <ul class="d_flex_end">
                  <li class=" d_flex_center" @click="editTodo(todo)"><img src="@/assets/media/images/edit.png" alt=""></li>
                  <li class=" d_flex_center" @click="deleteTodo(todo)"><img src="@/assets/media/images/trash.png" alt=""></li>
                </ul>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TodosComponent',
  data() {
    return {
      todos: [],
      form: {
        content: '',
      },
    };
  },
  created() {
    this.getTodos();
  },
  methods: {
    getTodos() {
      this.axios.get('/get-todos').then(({ data }) => {
        this.todos = data.data;
      });
    },
    editTodo(todo) {
      this.form = todo;
    },
    addUpdateTodo() {
      this.axios
        .post(`/store-update-todo`, this.form)
        .then(({ data }) => {
          if (data.success) {
            this.showSuccessMsg(data.message);
            this.getTodos();
            this.form = {
              content: '',
              id: '',
            };
          } else {
            this.showFailMsg(data.message);
          }
        })
        .catch(() => {
          this.showFailMsg('Something went wrong!');
        });
    },
    deleteTodo(todo) {
      this.axios
        .delete(`/delete-todo/${todo.id}`)
        .then(({ data }) => {
          if (data.success) {
            this.showSuccessMsg(data.message);
            this.getTodos();
          } else {
            this.showFailMsg(data.message);
          }
        })
        .catch(() => {
          this.showFailMsg('Something went wrong!');
        });
    },
    markAsCompleted(todo) {
      this.axios
        .post(`/todo-status-update/${todo.id}`)
        .then(({ data }) => {
          if (data.success) {
            this.showSuccessMsg(data.message);
            this.getTodos();
          } else {
            this.showFailMsg(data.message);
          }
        })
        .catch(() => {
          this.showFailMsg('Something went wrong!');
        });
    },
  },
};
</script>
<style scoped></style>
